module.exports = __webpack_public_path__ + "img/actbg@3x.f51c57f8.png";